import { fetchData, ENDPOINT_HOST } from './api_helper';
import store from '@/store/store';

const apiURL = `${ENDPOINT_HOST}users/`;

const loginUser = credentials => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}login`;
  fetchData(endpointURL, 'post', credentials, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const logoutUser = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}logout`;
  store.commit('inspections/resetAllInspections', null);
  fetchData(endpointURL, 'post', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const resetPasswordToken = userName => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}request_password_reset`;
  fetchData(endpointURL, 'post', userName, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const setPassword = (token, password) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}reset_password/${token}`;
  fetchData(endpointURL, 'post', { password }, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const registration = (invitationCode, params, language) => new Promise(((resolve, reject) => {
  const lang = language || 'en';
  const endpointURL = `${apiURL}registration/${invitationCode}?language=${lang}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchUser = id => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchWorkers = (partnerId, siteId, page, searchTerm = '', roles, orderInfo) => new Promise(((resolve, reject) => {
  let endpointURL = `${ENDPOINT_HOST}partners/${partnerId}/sites/${siteId}/users/?page=${page}&term=${searchTerm}`;
  if (roles) {
    endpointURL = `${endpointURL}&roles[]=${roles[0]}&roles[]=${roles[1]}&roles[]=${roles[2]}&roles[]=${roles[3]}`;
  }

  if (orderInfo) {
    endpointURL = `${endpointURL}&roles[]=${roles[0]}&roles[]=${roles[1]}&roles[]=${roles[2]}&roles[]=${roles[3]}&order=${orderInfo.order}&direction=${orderInfo.direction}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchWorker = (partnerId, siteId, userId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}partners/${partnerId}/sites/${siteId}/users/${userId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createWorker = (partnerId, siteId, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}partners/${partnerId}/sites/${siteId}/users/`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateWorker = (partnerId, siteId, userId, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}partners/${partnerId}/sites/${siteId}/users/${userId}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteWorker = (partnerId, siteId, userId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}partners/${partnerId}/sites/${siteId}/users/${userId} `;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchVivus = (partnerId, page) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users?roles=vivu`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchNotifications = (id, page) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notifications?page=${page}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateNotifications = id => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notifications/update_to_read`;
  fetchData(endpointURL, 'post', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createUserAction = (id, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/create_user_action`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchFeeds = (id, page) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/feeds?page=${page}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchFeed = (id, feedId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/feeds/${feedId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createFeed = (id, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/feeds`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateFeed = (id, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/feeds/${params.id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteFeed = (id, feedId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/feeds/${feedId}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchNotes = (id, page, partnerId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notes?page=${page}&partner_id=${partnerId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchNote = (id, noteId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notes/${noteId}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createNote = (id, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notes`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateNote = (id, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notes/${params.id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteNote = (id, noteId) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/notes/${noteId}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const changeUser = id => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${id}/change_user`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchSpecs = () => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}specializations`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPartnerAdmins = (page, orderInfo) => new Promise(((resolve, reject) => {
  let endpointURL = `${ENDPOINT_HOST}users?roles=partner_admin&page=${page}`;
  if (orderInfo && orderInfo.order) {
    endpointURL = `${ENDPOINT_HOST}users?roles=partner_admin&page=${page}&sort_by=${orderInfo.order}&order_direction=${orderInfo.direction}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createUser = params => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateUser = (userId, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${userId}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteUser = userId => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}users/${userId} `;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchAdmins = (page, orderInfo) => new Promise(((resolve, reject) => {
  let endpointURL = `${ENDPOINT_HOST}users?roles=admin&page=${page}`;
  if (orderInfo && orderInfo.order) {
    endpointURL = `${ENDPOINT_HOST}users?roles=admin&page=${page}&sort_by=${orderInfo.order}&order_direction=${orderInfo.direction}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


export default {
  loginUser,
  logoutUser,
  resetPasswordToken,
  setPassword,
  registration,
  fetchUser,
  fetchWorkers,
  createWorker,
  updateWorker,
  deleteWorker,
  fetchWorker,
  fetchVivus,
  fetchNotifications,
  updateNotifications,
  createUserAction,
  fetchFeeds,
  fetchFeed,
  createFeed,
  updateFeed,
  deleteFeed,
  fetchNotes,
  fetchNote,
  createNote,
  updateNote,
  deleteNote,
  changeUser,
  fetchSpecs,
  fetchPartnerAdmins,
  createUser,
  updateUser,
  deleteUser,
  fetchAdmins,
};



// WEBPACK FOOTER //
// ./src/api/users.js